import FloatingQuestion from '../Assessments/Marking/FloatingQuestion/FloatingQuestion';
import { useMemo, memo } from 'react';

const MemoizedFloatingQuestion = memo(FloatingQuestion);
const maxQuestionLength = 30;

const getTrimmedString = (str = '', length) => (str.length > length ? `${str.substring(0, length)}...` : str);

export const useCustomColumns = (user = null) => {
  const questions = useMemo(() => user?.questions ?? [], [user?.questions]);

  return useMemo(() => {
    return questions.map((item, index) => ({
      questionId: item?.questionId,
      label: (
        <MemoizedFloatingQuestion
          id={`floating-question-${index}`}
          prefix={getTrimmedString(`${item?.title}`, maxQuestionLength)}
          description={item?.title}
        />
      ),
      align: 'center',
      key: item?.title,
      hide: true,
      show: true,
      delete: true,
      className: 'text-center box-center',
      customSettingText: item?.title,
      hideSorting: true
    }));
  }, [questions]);
};
